// External dependencies
import $ from 'jquery';

/**
 * Create random unique ID for contact for 7
 */
const randID = Math.floor((Math.random() * 9999999999) + 1000000000);
$('.retouching-random-id').val(randID);

/**
 * QuerySelectorAll can instantiate multiple input field
 */
const allInput = document.querySelectorAll('.rul-phone-number');
const inst = [];
for (let i = 0; i < allInput.length; i++) {
	const singleInput = allInput[ i ];
	inst[ i ] = window.intlTelInput(singleInput, {
		// any initialization options go here
		initialCountry: 'auto',
		separateDialCode: true,
		geoIpLookup: function (callback) {
			$.ajax({
				type: 'post',
				dataType: 'json',
				url: window.RETO_ContactFormParams.ajax_url,
				data: {
					action: 'rul_get_country_code_action',
				},
				success(response) {
					if (response.status == 200) {
						callback(response.country_code);
					}
					else {
						callback('us');
					}
				}
			});

		},
		utilsScript: window.RETO_ContactFormParams.utils_js,
	});
}

const allNumberFields = $('.rul-phone-number');
/**
 * Event fire (country change) when scripts successfully loaded except country placeholder
 */
allNumberFields.each(function(i) {
	const countryInputFiled = $(this);
	allInput[ i ].addEventListener('countrychange', function() {
		const countryApi = inst[ i ].getSelectedCountryData();
		const fullNumber = inst[ i ].getNumber();
		countryInputFiled.closest('form').find('.rul-cf-country-name').val(countryApi.name);
		countryInputFiled.closest('form').find('.rul-cf-full-number').val(fullNumber);
		countryInputFiled.closest('form').find('.rul-cf-country-dail-code').val('+' + countryApi.dialCode);
		//console.log(country_api);
	});
	//update full number when type number in country code field
	$(this).on('input', function() {
		const fullNumber = inst[ i ].getNumber();
		countryInputFiled.closest('form').find('.rul-cf-full-number').val(fullNumber);
	});
});

/**
 * Disable all character except Digits - 1 to 9
 */
allNumberFields.keypress(function (e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});



/**
 * Static code only for Retouching Labs Website - Pricing Section
 */
$('.rl-pricing-section .d-grid .ordedr-btn').on('click', function (e) {
	e.preventDefault();
	$('body').addClass('popup-form-show');
	$('.rt-contact-form-section:not(.popup-form)').css({
		'visibility': 'hidden'
	});
});

/**
 * Dynamically popup event fire.
 */
Object.keys(RETO_ContactFormParams.popup_forms_events).forEach(function(key){
	if (key != '') {
		$('.'+ key).on('click', function (e) {
			e.preventDefault();
			$('body').addClass(key+'-form-show');
			$('.rt-contact-form-section:not(.popup-form)').css({
				'visibility': 'hidden'
			});
		});
	}
});



/**
 * Form Close action
 */
// $('.close-popup-form').on('click', function () {
// 	$('.rt-contact-form-section:not(.popup-form)').css({
// 		'visibility': 'visible'
// 	});
// 	//$('body').removeClass('popup-form-show').removeClass('quote-form-show').removeClass('button-form-show');
// 	Object.keys(RETO_ContactFormParams.popup_forms_events).forEach(function(key){
// 		if (key != '') {
// 			$('body').removeClass(key+'-form-show');
// 		}
// 	});

// 	/**
// 	 * CF7 form success message hide and form filed will be visiable
// 	 * Form status class modified
// 	 */
// 	setTimeout(function () {
// 		$('.popup-form .wpcf7-form').removeClass('sent').addClass('init');
// 		//$('.popup-form .cf-trigger-select-option').removeClass('clicked');
// 	}, 500);
// });

// /**
//  * Close popup form when click on outsite of popup form
//  */
// $('section.popup-form').on('click', function (e) {
// 	const popContainer = $('.popup-form-wrapper');

// 	// if the target of the click isn't the pop_container nor a descendant of the pop_container
// 	if (!popContainer.is(e.target) && popContainer.has(e.target).length === 0) {
// 		$('.rt-contact-form-section:not(.popup-form)').css({
// 			'visibility': 'visible'
// 		});
// 		Object.keys(RETO_ContactFormParams.popup_forms_events).forEach(function(key){
// 			if (key != '') {
// 				$('body').removeClass(key+'-form-show');
// 			}
// 		});

// 		/**
// 		 * CF7 form success message hide and form filed will be visible
// 		 * Form status class modified
// 		 */
// 		setTimeout(function () {
// 			$('.popup-form .wpcf7-form').removeClass('sent').addClass('init');
// 		}, 500);
// 	}
// });

// /**
//  * Prevent multiple cf submit request until first request complete
//  */
// var disableSubmit = false;

// const cfFormsSelector = document.querySelectorAll('.wpcf7');

// const cfForms = $('.wpcf7');

// cfForms.each(function (i) {
// 	let form = cfFormsSelector[i];
// 	let submitButton = $(form).find('input.wpcf7-submit[type = "submit"]');

// 	$(submitButton).on('click', function () {
// 		if (disableSubmit == true) {
// 			return false;
// 		}
// 		disableSubmit = true;
// 		return true;
// 	});

// 	form.addEventListener('wpcf7_before_send_mail', function (event) {
// 		disableSubmit = false;
// 	}, false);

// 	form.addEventListener('wpcf7invalid', function (event) {
// 		disableSubmit = false;
// 	}, false); 

// });
    

// Contant Form 7 submit button disable on click

jQuery(document).ready(function ($) {

	let disableSubmit = false;

	/**
	 * Form Close action
	 */
	$('.close-popup-form').on('click', function () {
		resetPopupForm();
	});

	/**
	 * Close popup form when click outside of popup form
	 */
	$('section.popup-form').on('click', function (e) {
		const popContainer = $('.popup-form-wrapper');
		if (!popContainer.is(e.target) && popContainer.has(e.target).length === 0) {
			resetPopupForm();
		}
	});

	/**
	 * Track when CF7 submit button clicked
	 */
	$('.wpcf7-form').on('submit', function () {
		if (disableSubmit) {
			return false; // prevent double submit
		}
		disableSubmit = true;
		$(this).find('input[type=submit], button[type=submit]').prop('disabled', true);
		$(this).addClass('submit-click');
	});

	/**
	 * Re-enable submit button after CF7 finishes
	 */
	document.addEventListener('wpcf7mailsent', function () {
		enableSubmitButton();
	}, false);

	document.addEventListener('wpcf7invalid', function () {
		enableSubmitButton();
	}, false);

	document.addEventListener('wpcf7mailfailed', function () {
		enableSubmitButton();
	}, false);

	function enableSubmitButton() {
		disableSubmit = false;
		$('.wpcf7-form').find('input[type=submit], button[type=submit]').prop('disabled', false);
	}

	/**
	 * Reset popup form helper
	 */
	function resetPopupForm() {
		$('.rt-contact-form-section:not(.popup-form)').css({
			'visibility': 'visible'
		});
		Object.keys(RETO_ContactFormParams.popup_forms_events).forEach(function (key) {
			if (key != '') {
				$('body').removeClass(key + '-form-show');
			}
		});

		// Reset CF7 form fields
		if ($('.popup-form .wpcf7-form').hasClass('sent')) {
			$('.popup-form .wpcf7-form .cf-reset-button').trigger('click');
		}

		// Reset CF7 state
		setTimeout(function () {
			$('.popup-form .wpcf7-form')
				.removeClass('sent invalid failed submitting')
				.addClass('init')
				.attr('data-status', 'init');
			enableSubmitButton(); 
		}, 50);
	}

});
